
  export default {
    props: {
      stars: { type: Number, default: 5 }
    }
  };
